import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { User } from 'src/app/calvin-emr-shared/models/user.model';
import {
  PATH_SETTINGS_PROFILE,
  PATH_SETTINGS_HELP,
  PATH_CHANGE_PASSWORD,
} from '../settings.global';
import { Store } from '@ngrx/store';
import { selectUser } from 'src/app/calvin-emr-shared/state/auth/auth.selector';
import { MenuModule } from 'primeng/menu';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['./settings-page.component.scss'],
    standalone: true,
    imports: [MenuModule, RouterOutlet],
})
export class SettingsPageComponent implements OnInit, OnDestroy {
  // Local constants
  changePasswordPath = '/' + PATH_CHANGE_PASSWORD;

  currentUserSub: Subscription;
  currentUser?: User;

  menuItems: MenuItem[] = [
    {
      label: 'My Profile',
      icon: 'pi pi-fw pi-user',
      routerLink: PATH_SETTINGS_PROFILE,
    },
    // {
    //   label: 'General',
    //   icon: 'pi pi-fw pi-cog',
    //   routerLink: PATH_SETTINGS_GENERAL,
    // },
    { separator: true },
    {
      label: 'Help',
      icon: 'pi pi-fw pi-question-circle',
      routerLink: PATH_SETTINGS_HELP,
    },
  ];

  constructor(private store: Store) {
    this.currentUserSub = this.store.select(selectUser).subscribe((user: User | null) => {
      if (user) {
        this.currentUser = user;
      }
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.currentUserSub.unsubscribe();
  }
}
